import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export const DEFAULT_TABLE_PAGE_SIZE = 10;

export const paginateItems = (items, page, pageSize = DEFAULT_TABLE_PAGE_SIZE) => {
  const totalItems = items.length;
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  const safePage = Math.min(Math.max(page, 1), totalPages);
  const startIndex = totalItems === 0 ? 0 : (safePage - 1) * pageSize + 1;
  const endIndex = totalItems === 0 ? 0 : Math.min(safePage * pageSize, totalItems);
  const pageItems = items.slice((safePage - 1) * pageSize, safePage * pageSize);

  return { totalItems, totalPages, safePage, startIndex, endIndex, pageItems };
};

export const TablePaginationBar = ({
  page,
  totalItems,
  pageSize = DEFAULT_TABLE_PAGE_SIZE,
  onPageChange,
  testIdPrefix,
  itemLabel = 'itens',
  className,
}) => {
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  const safePage = Math.min(Math.max(page, 1), totalPages);
  const start = totalItems === 0 ? 0 : (safePage - 1) * pageSize + 1;
  const end = totalItems === 0 ? 0 : Math.min(safePage * pageSize, totalItems);

  return (
    <div
      className={cn('flex flex-col gap-2 border-t border-slate-200 bg-slate-50/70 px-3 py-2 sm:flex-row sm:items-center sm:justify-between', className)}
      data-testid={`${testIdPrefix}-pagination`}
    >
      <p className="text-xs text-slate-600" data-testid={`${testIdPrefix}-pagination-summary`}>
        {start}-{end} de {totalItems} {itemLabel}
      </p>
      <div className="flex items-center gap-2">
        <span className="text-xs font-medium text-slate-600" data-testid={`${testIdPrefix}-pagination-page-indicator`}>
          Página {safePage} de {totalPages}
        </span>
        <Button
          type="button"
          variant="outline"
          size="sm"
          className="h-8 rounded-lg"
          disabled={safePage <= 1}
          onClick={() => onPageChange(safePage - 1)}
          data-testid={`${testIdPrefix}-pagination-prev`}
        >
          <ChevronLeft className="mr-1 h-4 w-4" />
          Anterior
        </Button>
        <Button
          type="button"
          variant="outline"
          size="sm"
          className="h-8 rounded-lg"
          disabled={safePage >= totalPages}
          onClick={() => onPageChange(safePage + 1)}
          data-testid={`${testIdPrefix}-pagination-next`}
        >
          Próxima
          <ChevronRight className="ml-1 h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};